var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignedSquareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6449",
    "data-name": "Groupe 6449",
    transform: "translate(0 -0.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3496",
    "data-name": "Rectangle 3496",
    transform: "translate(0 0.344)",
    fill: "#d9e7fd",
    stroke: "#4188f2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 86,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5701",
    "data-name": "Trac\\xE9 5701",
    d: "M47.583,15.372a4.3,4.3,0,0,0-6.072,0l-4.305,4.309V8.34A4.265,4.265,0,0,0,35.949,5.3L31.9,1.257A4.265,4.265,0,0,0,28.866,0H4.293A4.3,4.3,0,0,0,0,4.293V44.552a4.3,4.3,0,0,0,4.293,4.293h28.62a4.3,4.3,0,0,0,4.293-4.293V31.828L47.583,21.443a4.29,4.29,0,0,0,0-6.071M33.159,31.829l-.773.773L29.35,33.614l1.012-3.036.773-.773Zm2.023-2.024-2.024-2.024L40.037,20.9l2.024,2.024Zm-5.3-26.524,4.047,4.048a1.562,1.562,0,0,1,.419,1.257H28.62V2.862a1.562,1.562,0,0,1,1.257.419m3.036,42.7H4.293a1.433,1.433,0,0,1-1.431-1.431V4.293A1.433,1.433,0,0,1,4.293,2.862H25.758v7.155a1.431,1.431,0,0,0,1.431,1.431h7.155v11.1l-4.222,4.226L28.1,28.794a1.431,1.431,0,0,0-.346.559L25.73,35.424a1.431,1.431,0,0,0,1.81,1.81l6.071-2.024a1.43,1.43,0,0,0,.559-.346l.174-.174v9.861a1.433,1.433,0,0,1-1.431,1.431M45.559,19.419,44.084,20.9,42.06,18.872,43.536,17.4a1.431,1.431,0,1,1,2.023,2.024",
    transform: "translate(22.301 18.051)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5702",
    "data-name": "Trac\\xE9 5702",
    d: "M61.431,152.862H81.465a1.431,1.431,0,1,0,0-2.862H61.431a1.431,1.431,0,1,0,0,2.862",
    transform: "translate(-31.975 -117.639)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5703",
    "data-name": "Trac\\xE9 5703",
    d: "M61.431,212.862h14.31a1.431,1.431,0,0,0,0-2.862H61.431a1.431,1.431,0,0,0,0,2.862",
    transform: "translate(-31.975 -171.915)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5704",
    "data-name": "Trac\\xE9 5704",
    d: "M61.431,272.862h14.31a1.431,1.431,0,0,0,0-2.862H61.431a1.431,1.431,0,1,0,0,2.862",
    transform: "translate(-31.975 -226.191)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5705",
    "data-name": "Trac\\xE9 5705",
    d: "M77.172,331.431A1.431,1.431,0,0,0,75.741,330H61.431a1.431,1.431,0,1,0,0,2.862h14.31a1.431,1.431,0,0,0,1.431-1.431",
    transform: "translate(-31.975 -280.467)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5706",
    "data-name": "Trac\\xE9 5706",
    d: "M190.017,422h-8.586a1.431,1.431,0,0,0,0,2.862h8.586a1.431,1.431,0,1,0,0-2.862",
    transform: "translate(-140.527 -363.69)",
    fill: "#4188f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedSquareIcon);
export default __webpack_public_path__ + "static/media/signed-square-icon.f594f29e2b96923131e913fe78cb607a.svg";
export { ForwardRef as ReactComponent };